/**
 * @fileoverview Connect shared notification requests to the mounted toast surface. `ToastContext.js` exposes the caller interface and workspaces own message content. Provider lifetime owns presentation resources without acknowledging backend completion or replacing durable error/audit records.
 */

import React, { useRef } from 'react';
import { Toast } from 'primereact/toast';
import ToastContext from './ToastContext';



const ToastProvider = ({ children }) => {
    const toast = useRef(null);

    const showToast =

    ({ severity, summary, detail, life = 3000 }) => {
        toast.current.show({ severity, summary, detail, life });
    };

    return (
        <ToastContext.Provider value={showToast}>
            <Toast ref={toast} />
            {children}
        </ToastContext.Provider>
    );
};

export default ToastProvider;
